export function ensureProtocol(
  url?: string,
  defaultProtocol = "https://",
): string {
  if (!url) return "";
  if (!/^https?:\/\//i.test(url)) {
    return defaultProtocol + url;
  }
  return url;
}
